import {AfterViewInit, Component, OnInit} from '@angular/core';
import {RegistryService} from "../../../../services/registry.service";
import {CartService} from "../../../../services/cart.service";
import {Cart} from "../../../../models/CartModels/cart";

import {CartItem} from "../../../../models/CartModels/cartItem";
import {TranslateService} from "@ngx-translate/core";

@Component({
    selector: 'app-store-icon',
    templateUrl: './store-icon.component.html',
    styleUrls: ['./store-icon.component.css']
})
export class StoreIconComponent implements OnInit,AfterViewInit {

    selected_store;
    products_count = 0;
    cart: Cart;
    baseImageUrl;
    sum = 0;

    lang = 'en-US';

    currency_codes = [];

    stores = [
        {
            code: 'kw', name: "Kuwait", "icon": "assets/flags/kw.png", "storeview": "default"
            , url: "https://alarabiya.com.kw/"
        },
        {
            code: 'ksa', name: "Saudi Arabia", "icon": "assets/flags/ksa.png", "storeview": "storeview_sa",
            url: "https://sa.alarabiya.site/"
        }
    ]




    constructor(private registry: RegistryService,
                private cartService: CartService,
                public translate: TranslateService
    ) {





    }

    ngAfterViewInit(): void {
        this.setCurrentStore();
    }

    setCurrentStore() {

        if ( this.cartService?.storeview == "default" || this.cartService?.storeview == "ar")
        {
            this.selected_store = this.stores[0];
        }
        else{
            this.selected_store = this.stores[1];
        }
        // this.stores.forEach(function (s) {
        //
        //     if(this.cartService != undefined) {
        //         if (s.storeview == this.cartService?.storeview) {
        //             this.selected_store = s;
        //         }
        //     }
        // });


    }

    setDefault() {

        let service = this.cartService;
        let component = this;
        this.stores.forEach(function (s) {
            if (s.storeview == service.storeview) {
                component.selected_store = s;
            }
        });

    }

    ngOnInit(): void {

        this.lang = this.cartService.getCurrentLang();
        this.setDefault()

        //

    }

    storeChanged($event, store) {

        this.selected_store = store;
        //switch to store.
        window.location = this.selected_store.url;
    }


}
